// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.register-deposit-modal-modal_card-L4NcV {
  width: 340px;
  height: initial;
  min-height: 504px;
}

.register-deposit-modal-modal_content-JR4ki {
  padding: 0px 20px;
}

.register-deposit-modal-textField_container-aLnlz, .register-deposit-modal-dateTime_container-AxLmS, .register-deposit-modal-businessSelect-F6Mxg {
  width: 100%;
  margin-top: 24px;
}

.register-deposit-modal-textField_container-aLnlz:first-child {
  margin-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/customer/customer-deposits/register-deposit-modal/register-deposit-modal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".modal_card {\n  width: 340px;\n  height: initial;\n  min-height: 504px;\n}\n\n.modal_content {\n  padding: 0px 20px;\n}\n\n.textField_container, .dateTime_container, .businessSelect {\n  width: 100%;\n  margin-top: 24px;\n}\n\n.textField_container:first-child {\n  margin-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_card": `register-deposit-modal-modal_card-L4NcV`,
	"modal_content": `register-deposit-modal-modal_content-JR4ki`,
	"textField_container": `register-deposit-modal-textField_container-aLnlz`,
	"dateTime_container": `register-deposit-modal-dateTime_container-AxLmS`,
	"businessSelect": `register-deposit-modal-businessSelect-F6Mxg`
};
export default ___CSS_LOADER_EXPORT___;
